import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import './styles/additionalData.scss';
import configuration from 'config';
import { messagePropTypes, surveyAdditionalDataPropTypes } from '../propTypes';
import { ADDITIONAL_DATA_TYPE } from 'reducers/chat/interactiveSurvey';

class ChatInteractiveSurveyAsk extends Component {
  static propTypes = {
    caseNumber: PropTypes.number.isRequired,
    className: PropTypes.string,
    message: messagePropTypes.isRequired,
    answered: PropTypes.object.isRequired,
    errorSavingSurveyMessage: PropTypes.string,
    surveySuccessfullySavedMessage: PropTypes.string,
    surveyTextFooter: PropTypes.string,
    dataMandatoryMessage: PropTypes.string,
    mustSelectanOptionMessage: PropTypes.string,
    currentAdditionalDataIndex: PropTypes.number.isRequired,
    nextAdditionalData: surveyAdditionalDataPropTypes,
    onAnswer: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      answer: '',
      validationError: undefined,
    };

    this.isList = this.props.message.additionalData.additionalDataType === ADDITIONAL_DATA_TYPE.listvalue;
  }
  componentClass() {
    switch (this.props.message.additionalData.additionalDataType) {
      case ADDITIONAL_DATA_TYPE.textarea:
        return 'textarea';
      case ADDITIONAL_DATA_TYPE.listvalue:
        return 'select';
      default:
        return undefined;
    }
  }
  changeAnswer(e) {
    this.setState({ answer: e.target.value, validationError: undefined });
  }
  answerKeyPress(e) {
    if (e.which === 13) {
      e.preventDefault();
      this.answer();
    }
  }
  answer() {
    if (this.props.message.additionalData.isMandatory && this.state.answer === '') {
      this.setState({ validationError: this.isList
        ? this.props.mustSelectanOptionMessage : this.props.dataMandatoryMessage
      });
      return;
    }

    this.props.onAnswer(
      this.props.nextAdditionalData,
      this.props.currentAdditionalDataIndex,
      this.props.message.additionalData.additionalDataId,
      this.state.answer,
      this.isList
        ? this.props.message.additionalData.surveyAdditionalDataListsValue
          .find(lv => lv.listValue === this.state.answer).listText
        : this.state.answer
    );

    if (this.props.nextAdditionalData === undefined) {
      this.props.onSubmit(
        this.props.caseNumber,
        this.props.answered
          .map(a => a.answer)
          .set(this.props.message.additionalData.additionalDataId, this.state.answer)
          .toObject(),
        this.props.surveySuccessfullySavedMessage,
        this.props.errorSavingSurveyMessage,
        this.props.surveyTextFooter
      );
    }
  }
  render() {
    let { additionalData } = this.props.message;
    return (
      <div className={'interactive-survey-message-additional-data ' + this.props.className}>
        <p className="interactive-survey-message-additional-data-label">{this.props.message.content}</p>
        {
          !Array.from(this.props.answered.keys()).some(a => a === additionalData.additionalDataId) ? (
            <div className="interactive-survey-message-additional-data-input-wraper text-center">
              <B.Grid fluid>
                <B.Row className="show-grid">
                  <B.Col xs={9}>
                    <B.FormControl
                      autoFocus
                      type={additionalData.additionalDataType === ADDITIONAL_DATA_TYPE.textbox ? 'text' : undefined}
                      componentClass={this.componentClass()}
                      value={this.state.answer}
                      onChange={this.changeAnswer.bind(this)}
                      onKeyPress={this.answerKeyPress.bind(this)}
                      className="interactive-survey-message-additional-data-input"
                      placeholder={this.isList ? undefined : 'Write your answer here'}
                    >
                      {
                        this.isList ? (
                          [<option key="undefined" value="">Select an option</option>].concat(
                            additionalData.surveyAdditionalDataListsValue
                              .map(lv => <option key={lv.listValue} value={lv.listValue}>{lv.listText}</option>)
                          )
                        ) : undefined
                      }
                    </B.FormControl>
                  </B.Col>
                  <B.Col xs={3}>
                    <B.Button className="interactive-survey-message-additional-data-ok-button"
                      bsStyle="success" onClick={this.answer.bind(this)}>
                      <B.Glyphicon glyph="ok" />
                    </B.Button>
                  </B.Col>
                </B.Row>
              </B.Grid>
              { this.state.validationError ? <p className="interactive-survey-message-additional-data-error text-danger">{this.state.validationError}</p> : undefined }
            </div>
          ) : undefined
        }
      </div>
    );
  }
};

export default ChatInteractiveSurveyAsk;



// WEBPACK FOOTER //
// ./components/chat/interactiveSurvey/AdditionalData.js